import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Alert, Container, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Register.css';
import apiClient from '../apis/apiClient';

const Register = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    roles: ['USER'] // default role
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.username.trim()) {
      newErrors.username = 'Username is required';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email';
    }

    if (!formData.password) {
      newErrors.password = 'Password is required';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
    }

    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setIsSubmitting(true);

      try {
        const response = await apiClient.post('/auth/register', formData);
        const result = response.data;

        if (response.ok) {
          setRegistrationSuccess(true);
          setTimeout(() => {
            navigate('/login'); // redirect to login after success
          }, 2000);
        } else {
          setErrors({ submit: result || 'Registration failed. Try again.' });
        }

      } catch (error) {
        console.error('Registration error:', error);
        setErrors({ submit: 'An unexpected error occurred.' });
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <Container className="register-container">
      <Card className="register-card">
        <Card.Body>
          <div className="register-header">
            <h2>Erstellen Sie Ihr Konto</h2>
            <p>Werden Sie noch heute Teil der Papadam-Familie</p>
          </div>

          {registrationSuccess ? (
            <Alert variant="success" className="register-success">
              <h5>Registrierung erfolgreich!</h5>
              <p>Weiterleitung zur Anmeldeseite...</p>
            </Alert>
          ) : (
            <Form onSubmit={handleSubmit} className="register-form">
              {errors.submit && <Alert variant="danger">{errors.submit}</Alert>}

              <Form.Group className="mb-4" controlId="formUsername">
                <Form.Label>Username</Form.Label>
                <Form.Control
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  isInvalid={!!errors.username}
                  placeholder="Geben Sie Ihren Benutzernamen ein"
                />
                <Form.Control.Feedback type="invalid">{errors.username}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-4" controlId="formEmail">
                <Form.Label>E-Mail-Adresses</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  isInvalid={!!errors.email}
                  placeholder="Geben Sie Ihre E-Mail-Adresse ein"
                />
                <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-4" controlId="formPassword">
                <Form.Label>Passwort</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  isInvalid={!!errors.password}
                  placeholder="Erstellen Sie ein Passwort"
                />
                <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
                <Form.Text className="text-muted">
                  Muss mindestens 6 Zeichen lang sein
                </Form.Text>
              </Form.Group>

              <Form.Group className="mb-4" controlId="formConfirmPassword">
                <Form.Label>Passwort bestätigen</Form.Label>
                <Form.Control
                  type="password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  isInvalid={!!errors.confirmPassword}
                  placeholder="Bestätigen Sie Ihr Passwort"
                />
                <Form.Control.Feedback type="invalid">{errors.confirmPassword}</Form.Control.Feedback>
              </Form.Group>

              <Button
                variant="primary"
                type="submit"
                className="register-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Registrieren...
                  </>
                ) : 'Benutzerkonto erstellen'}
              </Button>

              <div className="login-redirect mt-3">
                <p>Hast du schon ein Konto? <a href="/login">Melden Sie sich hier an</a></p>
              </div>
            </Form>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Register;